export default "__VITE_ASSET__BSdhzE6A__"